import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import openWithFairePath, { route as openWithFaireRoute } from "@faire/web-api--source/routes/open-with-faire";
import openWithFaireAcademyPath, { route as openWithFaireAcademyRoute } from "@faire/web-api--source/routes/open-with-faire/academy";
import { route as openWithFaireAcademyBuyRetailInventoryRoute } from "@faire/web-api--source/routes/open-with-faire/academy/buy-retail-inventory";
import { route as openWithFaireAcademyFindRetailSpaceRoute } from "@faire/web-api--source/routes/open-with-faire/academy/find-retail-space";
import { route as openWithFaireAcademyFundingLicensingRoute } from "@faire/web-api--source/routes/open-with-faire/academy/funding-licensing";
import { route as openWithFaireAcademyLayTheGroundworkRoute } from "@faire/web-api--source/routes/open-with-faire/academy/lay-the-groundwork";
import { route as openWithFaireAcademyOrganizeStoreOperationsRoute } from "@faire/web-api--source/routes/open-with-faire/academy/organize-store-operations";
import { route as openWithFaireAcademyPromoteYourStoreRoute } from "@faire/web-api--source/routes/open-with-faire/academy/promote-your-store";
import { route as openWithFaireAcademyRenovateYourStoreRoute } from "@faire/web-api--source/routes/open-with-faire/academy/renovate-your-store";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export var useGetOpenWithFaireDesktopBreadcrumbOptions = function() {
    var pathname = useLocation().pathname;
    var strictLocalize = useStrictLocalization().strictLocalize;
    return useMemo(function() {
        var openWithFaireLanding = {
            label: strictLocalize({
                id: "sox/wR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Open with Faire"
                    }
                ]
            }),
            path: openWithFairePath()
        };
        var openWithFaireFaireAcademyLanding = {
            label: strictLocalize({
                id: "dpQSIi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Guides"
                    }
                ]
            }),
            path: openWithFaireAcademyPath()
        };
        var _obj;
        var faireAcademyGuidesBreadcrumbMap = (_obj = {}, _define_property(_obj, openWithFaireAcademyBuyRetailInventoryRoute, {
            label: strictLocalize({
                id: "qBRJsq",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Plan & buy inventory"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyFindRetailSpaceRoute, {
            label: strictLocalize({
                id: "BWv+Nm",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Find a space"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyFundingLicensingRoute, {
            label: strictLocalize({
                id: "dUFhm6",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Get funding & licenses"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyLayTheGroundworkRoute, {
            label: strictLocalize({
                id: "lGFyTa",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lay the groundwork"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyOrganizeStoreOperationsRoute, {
            label: strictLocalize({
                id: "G7n5o2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Organize your operations"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyPromoteYourStoreRoute, {
            label: strictLocalize({
                id: "yJ5QML",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Promote your store"
                    }
                ]
            })
        }), _define_property(_obj, openWithFaireAcademyRenovateYourStoreRoute, {
            label: strictLocalize({
                id: "bxixfl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Renovate your store"
                    }
                ]
            })
        }), _obj);
        if (pathMatchesRoute(pathname, openWithFaireRoute)) {
            return [
                _object_spread_props(_object_spread({}, openWithFaireLanding), {
                    path: undefined
                })
            ];
        }
        var breadcrumbOptions = [
            openWithFaireLanding
        ];
        if (pathMatchesRoute(pathname, openWithFaireAcademyRoute)) {
            breadcrumbOptions.push(_object_spread_props(_object_spread({}, openWithFaireFaireAcademyLanding), {
                path: undefined
            }));
        }
        var faireAcademyGuideRoutes = Object.keys(faireAcademyGuidesBreadcrumbMap);
        var matchedRoute = faireAcademyGuideRoutes.find(function(route) {
            return pathMatchesRoute(pathname, route);
        });
        if (matchedRoute) {
            var breadcrumbOption = faireAcademyGuidesBreadcrumbMap[matchedRoute];
            if (breadcrumbOption) {
                breadcrumbOptions.push(openWithFaireFaireAcademyLanding);
                breadcrumbOptions.push(breadcrumbOption);
            }
        }
        return breadcrumbOptions;
    }, [
        pathname,
        strictLocalize
    ]);
};
